import { IGlobalState } from "@/store";
import { Store } from "vuex";
import * as Types from '@/store/action-types';

/**
 * 获取接口分组目录树
 */
export async function useAPIGroupMenuData(store: Store<IGlobalState>) {
    await store.dispatch(`doc/${Types.SET_DOC_GROUP_LIST}`);
};

/**
 * 获取接口列表
 */
export async function useAPIData(store: Store<IGlobalState>,groupId: string) {
    await store.dispatch(`doc/${Types.SET_DOC_API_LIST}`,{
        groupId:groupId
    });
};

/**
 * 获取接口详情
 */
export async function useAPIInfo(store: Store<IGlobalState>,id: string) {
    await store.dispatch(`doc/${Types.SET_DOC_API_INFO}`,{
        id:id
    });
};

/**
 * 获取接口参数
 */
export async function useAPIParams(store: Store<IGlobalState>,apiId: string) {
    await store.dispatch(`doc/${Types.SET_DOC_API_PARAMS}`,{
        apiId:apiId
    });
};

/**
 * 获取接口详情
 */
export async function useAPIReturnParams(store: Store<IGlobalState>,apiId: string) {
    await store.dispatch(`doc/${Types.SET_DOC_API_RETURN_PARAMS}`,{
        apiId:apiId
    });
};